import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Info, Scale } from 'lucide-react';

export const TaxBaremeInfo = () => {
  return (
    <Card className="border border-slate-200" data-testid="tax-bareme-info-card">
      <CardHeader className="border-b border-slate-100">
        <CardTitle className="font-outfit text-base flex items-center gap-2">
          <Scale className="w-4 h-4 text-slate-500" /> Barèmes fiscaux applicables (à titre informatif)
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div
          className="rounded-md border-2 border-amber-400 bg-amber-50 p-3 mb-4 flex items-start gap-2"
          data-testid="tax-warning"
        >
          <Info className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" />
          <p className="text-xs text-amber-900 leading-relaxed">
            <b>Attention</b> ceci est à utiliser comme outil d'aiguillage / d'estimation car il ne prend
            pas en compte la totalité des variables permettant d'avoir les montants exacts au centime près
            (foyer fiscal, charges déductibles, etc.).
          </p>
        </div>

        <p className="text-xs text-slate-500 flex items-start gap-1.5 mb-3">
          <Info className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          Le barème progressif s'applique par tranches : chaque tranche est imposée à son propre taux,
          uniquement sur la part du revenu qui s'y trouve.
        </p>
        <table className="w-full text-sm mb-5">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500 text-xs uppercase">
              <th className="text-left py-2 px-3 font-medium">Tranche de revenu (IR)</th>
              <th className="text-right py-2 px-3 font-medium">Taux d'imposition</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-slate-100" data-testid="bareme-row-0">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">0 € à 11 294 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">0%</td>
            </tr>
            <tr className="border-b border-slate-100" data-testid="bareme-row-1">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">11 295 € à 28 797 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">11%</td>
            </tr>
            <tr className="border-b border-slate-100" data-testid="bareme-row-2">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">28 798 € à 82 341 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">30%</td>
            </tr>
            <tr className="border-b border-slate-100" data-testid="bareme-row-3">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">82 342 € à 177 106 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">41%</td>
            </tr>
            <tr data-testid="bareme-row-4">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">Au-delà de 177 106 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">45%</td>
            </tr>
          </tbody>
        </table>

        <p className="text-xs text-slate-500 flex items-start gap-1.5 mb-2">
          <Info className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          Barème de l'Impôt sur les Sociétés (IS) — applicable aux PME éligibles au taux réduit :
        </p>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500 text-xs uppercase">
              <th className="text-left py-2 px-3 font-medium">Tranche de bénéfice (IS)</th>
              <th className="text-right py-2 px-3 font-medium">Taux d'imposition</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-slate-100" data-testid="bareme-is-row-0">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">Bénéfice &lt; 42 500 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">15%</td>
            </tr>
            <tr data-testid="bareme-is-row-1">
              <td className="py-2 px-3 text-slate-700 font-mono text-xs">Bénéfice ≥ 42 500 €</td>
              <td className="py-2 px-3 text-right font-mono font-semibold">25%</td>
            </tr>
          </tbody>
        </table>
        <p className="text-xs text-slate-400 mt-3">
          Sources : barème IR 2024 (revenus 2023), taux IS PME en vigueur. À utiliser à titre indicatif uniquement.
        </p>
      </CardContent>
    </Card>
  );
};

export default TaxBaremeInfo;
